import { FC, ReactNode } from 'react';

import { useHoldsAndCheckoutsPageConfig } from '@app/hooks';

interface HoldsAndCheckoutsMessageProps {
  requestsMessage: ReactNode;
  holdsMessage: ReactNode;
}
export const HoldsAndCheckoutsMessage: FC<HoldsAndCheckoutsMessageProps> = ({
  requestsMessage,
  holdsMessage,
}) => {
  const { selectConfiguredOption } = useHoldsAndCheckoutsPageConfig();

  return <>{selectConfiguredOption(requestsMessage, holdsMessage)}</>;
};
